// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3U2EN","content":"styles_content__2M0BG"};